import React, { useContext, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { animated, useSpring } from 'react-spring';
import StatBlock from 'components/statBlock/statBlock';
import IconCar from 'icons/iconCar';
import { getMillionsShort } from 'helpers/utils';
import IconDTP from 'icons/iconDTP';
import IconCone from 'icons/iconCone';
import { UiContext } from 'uiContext';
import SpeedStatMobileExtended from 'components/speedStat/speedStatMobileExtended';
import { DateTimeString, WeatherType } from 'mobx/commonTypes';
import WeatherForecastMobile from 'components/weatherForecast/weatherForecastMobile';
import { SpeedStatProps } from 'components/speedStat/speedStatDesktop';

export default function DropdownMenuInnerMobile({
  isOpen,
  transport_count,
  large_accidents,
  roadwork_detail,
  speedStatProps,
  forecastSlot,
  weather,
  dateTime,
}: {
  isOpen: boolean;
  transport_count: number;
  large_accidents: number;
  roadwork_detail: number;
  speedStatProps: SpeedStatProps;
  forecastSlot: React.ReactNode;
  weather: WeatherType;
  dateTime: DateTimeString;
}) {
  const theme = useTheme();
  const {
    spacings: { sp },
  } = useContext(UiContext);
  const [maxHeight, setMaxHeight] = useState(0);

  const AnimeBox = animated(Box);
  const anime = useSpring({
    maxHeight: isOpen ? maxHeight : 0,
    marginBottom: isOpen ? parseFloat(theme.spacing(sp.s25)) : 0,
  });

  const { isTablet } = useContext(UiContext);

  return (
    <AnimeBox
      style={anime}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 1,
        overflow: 'hidden',
        height: 'auto',
      }}
    >
      <Box
        ref={(el: HTMLDivElement | null) => {
          if (el) {
            setMaxHeight(el.offsetHeight);
          }
        }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: sp.s30,
          width: 1,
        }}
      >
        <SpeedStatMobileExtended
          forecastSlot={forecastSlot}
          {...speedStatProps}
        ></SpeedStatMobileExtended>
        <Box
          sx={
            isTablet
              ? {
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: sp.s25,
                  py: sp.s25,
                }
              : {
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                }
          }
        >
          {!isTablet && <WeatherForecastMobile weather={weather} />}
          <StatBlock
            text="Кол-во уникальных автомобилей"
            icon={<IconCar></IconCar>}
            value={getMillionsShort(transport_count)}
            timeText="сегодня"
          ></StatBlock>
          <StatBlock
            text="Крупные ДТП"
            icon={<IconDTP></IconDTP>}
            value={String(large_accidents)}
            timeText="сейчас"
          ></StatBlock>
          <StatBlock
            text="Дорожные работы"
            icon={<IconCone></IconCone>}
            value={String(roadwork_detail)}
            timeText="сегодня"
          ></StatBlock>
          {isTablet && <WeatherForecastMobile weather={weather} />}
        </Box>
      </Box>
    </AnimeBox>
  );
}
